export default __webpack_public_path__ + "static/media/streak-hover.7b75a125.svg";